<template>
  <div class="event-item">
    <div class="event-icon left-side" :class="eventInfo.class">
      <img v-if="eventInfo.imgSrc" :src="eventInfo.imgSrc" />
    </div>
    <div class="inline-block">
      <div class="status-text secondary-font">
        {{ eventInfo.text | firstLetterCapitalize }}
      </div>
      <div>{{ moment(item.TimeStamp).format('h:mm A') }}</div>
      <div v-if="item.Duration">
        <div class="status-text mt-5 secondary-font">
          {{ $t('text.duration') }}
        </div>
        <div>{{ item.Duration | secondFormat }}</div>
      </div>
      <!-- if pad end, should show some summary info -->
      <div v-if="shouldShowPadInfoEventTypes.includes(item.Status)">
        <div class="status-text secondary-font mt-5">
          {{ app.$i18n.t('text.product_name') }}
        </div>
        <div>{{ dayItem.ProductName || '--' }}</div>
        <div class="status-text secondary-font mt-5">
          {{ app.$i18n.t('text.total_void') }}
        </div>
        <div>
          <span>{{
            dayItem.TotalVoid !== '' ? dayItem.TotalVoid + 'ml' : '--'
          }}</span>
          <img
            v-if="dayItem.PadCycleType === 2"
            class="w-22 h-22 ml-5"
            :src="require('@/assets/image/VoidingPatternIcon/ai.svg')"
          />
        </div>
        <div class="status-text secondary-font mt-5">
          {{ app.$i18n.t('text.utilisation') }}
        </div>
        <div>
          {{ dayItem.PadStatus !== '' ? dayItem.PadStatus + '%' : '--' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { app } from '@/main.js'
import moment from 'moment'
import { voidConst } from '@/components/patients/charts/smartzEventsChart/SmartzEventConst.js'
export default {
  data() {
    return {
      app,
      moment,
      shouldShowPadInfoEventTypes: [
        voidConst.padEndLevel1,
        voidConst.padEndLevel2,
        voidConst.padEndLevel3,
        voidConst.padEndLevel4,
        voidConst.padEndLevel5
      ]
    }
  },
  props: {
    eventInfo: {
      type: Object,
      require: false,
      default: function() {
        return {
          text: '',
          imgSrc: '',
          class: ''
        }
      }
    },
    item: {
      type: Object,
      require: true
    },
    dayItem: {
      type: Object,
      require: true
    }
  }
}
</script>
